import { Chain } from 'viem/chains';
import { BLOCKCHAINS, CHAIN_CONFIGS, isEvmChain, getEvmChainId } from './providers';

export const getNativeCurrency = (chain: BLOCKCHAINS): Chain['nativeCurrency'] => {
  if (isEvmChain(chain)) {
    const chainId = getEvmChainId(chain);
    const web3Chain: Chain = CHAIN_CONFIGS.get(chainId);
    if (web3Chain) {
      return web3Chain.nativeCurrency;
    }
  } else if (chain === BLOCKCHAINS.ALGORAND) {
    return {
      decimals: 6,
      name: 'Algorand',
      symbol: 'ALGO',
    };
  } else if (chain === BLOCKCHAINS.SOLANA) {
    return {
      decimals: 9,
      name: 'Solana',
      symbol: 'SOL',
    };
  }
};

export const getWeb3ChainInfo = (chain: BLOCKCHAINS): Chain | undefined => {
  const chainId = getEvmChainId(chain);
  const web3Chain: Chain = CHAIN_CONFIGS.get(chainId);
  return web3Chain;
};
